
//import {db, functions} from "@/scripts/firebase";
import {SchedulingSheet } from "@/common-datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator"
import {query, orderBy, Unsubscribe, endAt, getDocs} from 'firebase/firestore'
import ModalSchedulingMessenger from "@/components/ModalStaffSchedulingMessenger.vue"
import SchedulingTable from "@/components/SchedulingTable.vue"
import StaffInboxOnReferenceObjects from "@/components/StaffInboxOnReferenceObjects.vue"
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'

@Component({
  components: {
    ModalSchedulingMessenger,
    SchedulingTable,
    StaffInboxOnReferenceObjects,
  }
})


export default class SchedulingList extends Mixins(Common) {
  observers: (Unsubscribe | undefined)[] = []
  showModalSchedulingMessenger = false

  defaultModalMessengerProps = {
    replyMessageId: '',
    replyAllMessageId: '',
    reviewMessageId: '',
    theMessageId: '',
    theSchedulingData: undefined as (undefined | SchedulingSheet)
  }

  modalMessengerProps = {} as this["defaultModalMessengerProps"]

  schedulingSheets: SchedulingSheet[] = []
  schedulingSheetsProps = {} as {[key: string]: {hidden: boolean}}
  isLoading = false
 
  get observer(){
    return this.$refs.schedulingSheetSearchFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  search = ''

  searchResult = ''

  searchResultsNum = 0

  init = false

  updated(){
   const hash = this.$route.query.schedulingId || ''
   if(this.init && hash){
     const targetEl =  this.$el.querySelector('#' + hash)
      if(targetEl){
        targetEl.scrollIntoView({behavior: 'smooth'})
      }
      this.init = false
   }
  }
  
  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0
    this.schedulingSheets.forEach((sheet) => {
      if(sheet.docId){
        if(val.length === 0){
          this.schedulingSheetsProps[sheet.docId] = {hidden: false}
          return
        }

        if((sheet.title && sheet.title.indexOf(val) > -1) || (sheet.comment && sheet.comment.indexOf(val) > -1)){
          this.schedulingSheetsProps[sheet.docId] = {hidden: false}
          searchResultsNum ++
          return
        }

        this.schedulingSheetsProps = {
          ...this.schedulingSheetsProps,
          [sheet.docId]: {hidden: true}
        }
      }
    })

    if(val && searchResultsNum === 0){
      this.searchResult = this.$t('groupList.notFound') as string
    }else{
      this.searchResult = ''
    }
    this.searchResultsNum = searchResultsNum
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const schedulingSheetsQuery = query(this.$getSchedulingSheetsColRef(),orderBy('end','desc'),endAt(Date.now()))

      const schedulingSheets = await getDocs(schedulingSheetsQuery)
      schedulingSheets.forEach((doc) => {
        const row = {
          ...doc.data(),
        } as SchedulingSheet

        if(! this.schedulingSheetsProps[doc.id]){
          this.schedulingSheetsProps[doc.id] = {
            hidden: false
          }
        }
        const findIndex = this.schedulingSheets.findIndex((sheet) => {return sheet.docId === doc.id})
        const deleteCount = (findIndex === -1 ? 0 : 1)
        this.schedulingSheets.splice(findIndex,deleteCount,row)

        this.schedulingSheets.sort((a,b) => {
          if(a.start && b.start){
            return a.start. getTime() - b.start.getTime()
          }
          return 0
        })
      })
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.init = true
    }
  }

  sendScheduling(sheet: SchedulingSheet){
    console.log(sheet)
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theSchedulingData: sheet
    }
    this.showModalSchedulingMessenger = true
  }

  editMessage(messageId: string,sheet: SchedulingSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theMessageId: messageId,
      theSchedulingData: sheet
    }
    this.showModalSchedulingMessenger = true
  }

  replyMessage(messageId: string,sheet: SchedulingSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyMessageId: messageId,
      theSchedulingData: sheet
    }
    this.showModalSchedulingMessenger = true
  }

  replyAllMessage(messageId: string,sheet: SchedulingSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyAllMessageId: messageId,
      theSchedulingData: sheet
    }
    this.showModalSchedulingMessenger = true
  }

  reviewMessage(messageId: string,sheet: SchedulingSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      reviewMessageId: messageId,
      theSchedulingData: sheet
    }
    this.showModalSchedulingMessenger = true
  }
 
  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
